
export const Footer = () => {
  const address = "48 Tanced Road, Glenhazel, Johannesburg, 2192";
  const encodedAddress = encodeURIComponent(address);
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

  return (
    <footer className="bg-white text-primary">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-semibold mb-4">Functional Foodie</h3>
            <p className="text-sm">Empowering healthy lives through personalised nutrition.</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4">Contact</h3>
            <a 
              href={googleMapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-primary-light transition-colors"
            >
              <p className="text-sm">48 Tanced Road</p>
              <p className="text-sm">Glenhazel, Johannesburg, 2192</p>
            </a>
            <p className="text-sm">
              Phone: <a href="tel:+27783515631" className="hover:text-primary-light transition-colors">+27783515631</a>
            </p>
            <p className="text-sm">
              Email: <a href="mailto:info@functionalfoodie.co.za" className="hover:text-primary-light transition-colors">info@functionalfoodie.co.za</a>
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4">Hours</h3>
            <p className="text-sm">Monday - Thursday: 7am - 6pm</p>
            <p className="text-sm">Friday: 7am - 4pm</p>
            <p className="text-sm">Saturday: Closed</p>
            <p className="text-sm">Sunday: Closed</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-4">Service Areas</h3>
            <p className="text-sm"><a href="/dietitian-glenhazel" className="hover:text-primary-light transition-colors">Dietitian in Glenhazel</a></p>
            <p className="text-sm"><a href="/dietitian-sandton" className="hover:text-primary-light transition-colors">Dietitian in Sandton</a></p>
            <p className="text-sm"><a href="/dietitian-randburg" className="hover:text-primary-light transition-colors">Dietitian in Randburg</a></p>
            <p className="text-sm"><a href="/dietitian-fourways" className="hover:text-primary-light transition-colors">Dietitian in Fourways</a></p>
            <p className="text-sm"><a href="/dietitian-rosebank" className="hover:text-primary-light transition-colors">Dietitian in Rosebank</a></p>
            <p className="text-sm mt-2"><a href="/blog" className="hover:text-primary-light transition-colors">Nutrition Blog</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
};
